<div class="overview-landing">
  <ng-container *ngFor="let componentItem of pageComponents">
    <ng-container [ngSwitch]="componentItem.type">
      <div *ngSwitchCase="'product-hero-banner'">
        <app-product-hero-banner [data]="componentItem" (startQuoteEvent)="startQuote($event)"></app-product-hero-banner>
      </div>
      <div *ngSwitchCase="'product-cross-content'">
        <app-product-cross-content [data]="componentItem" (startQuoteEvent)="startQuote($event)"></app-product-cross-content>
      </div>
      <div *ngSwitchCase="'product-callout'">
        <app-product-callout [data]="componentItem"></app-product-callout>
      </div>
      <div *ngSwitchCase="'product-text-block'">
        <app-product-text-block [data]="componentItem"></app-product-text-block>
      </div>
      <div *ngSwitchCase="'product-accordion'">
        <app-product-accordion [data]="componentItem"></app-product-accordion>
      </div>
      <div *ngSwitchCase="'product-features'">
        <app-product-features [data]="componentItem"></app-product-features>
      </div>
      <div *ngSwitchCase="'product-features-table'">
        <app-product-features-table [data]="componentItem"></app-product-features-table>
      </div>
      <div *ngSwitchCase="'product-card'">
        <app-product-card [data]="componentItem" (startQuoteEvent)="startQuote($event)"></app-product-card>
      </div>
      <div *ngSwitchCase="'product-trustpilot'">
        <app-product-trustpilot [data]="componentItem"></app-product-trustpilot>
      </div>
      <div *ngSwitchCase="'product-banner'">
        <app-product-banner [data]="componentItem" (startQuoteEvent)="startQuote($event)"></app-product-banner>
      </div>
    </ng-container>
  </ng-container>
</div>